import { createContext } from 'preact';

const ContextOne = createContext();

export default ContextOne;
